import { useEffect } from 'react'
import Nav from '@mc/navigation'
import { Locations, trackExperimentViewed } from '@mc/track-event'
import { AtWorkLink } from 'components/Navigation/shared/AtWorkLink'
import { CertificatesLink } from 'components/Navigation/shared/CertificatesLink'
import { MCCERTS_NAVIGATION_TESTING_PRE_PAYWALL_EXP_FLAG } from 'experiments/mccerts-280_v1/constants'
import { MasterClassLink } from './MasterClassLink'
import classes from './TopNavigation.module.scss'

export const TopNavigation = ({
  contained = false,
  className,
}: {
  contained?: boolean
  className?: string
}) => {
  useEffect(() => {
    trackExperimentViewed(MCCERTS_NAVIGATION_TESTING_PRE_PAYWALL_EXP_FLAG)
  }, [])

  return (
    <Nav
      background='transparent'
      className={`mc-bg-neutral-1000 d-none d-lg-block mc-theme-dark ${className}`}
      navChildClassName={`flex-nowrap ${classes.navChild}`}
      contained={contained}
    >
      <Nav.Left>
        <MasterClassLink
          className='mc-text-x-small mc-text--bold mc-ml-0'
          location={Locations.UTILITY_NAVIGATION}
        />
        <CertificatesLink
          className='mc-text-x-small mc-text--bold mc-ml-8'
          location={Locations.UTILITY_NAVIGATION}
        />
        <AtWorkLink
          className='mc-text-x-small mc-text--bold mc-ml-8'
          location={Locations.UTILITY_NAVIGATION}
        />
      </Nav.Left>
    </Nav>
  )
}
